import { getNavigation } from '@react-navigation/core';
import invariant from 'invariant';
import { initAction } from './reducer';
var reduxSubscribers = new Map();

function getReduxSubscribers(key) {
  var subscribers = reduxSubscribers.get(key);

  if (!subscribers) {
    subscribers = new Set();
    reduxSubscribers.set(key, subscribers);
  }

  return subscribers;
} // screenProps are a legacy concept in React Navigation,
// and should not be used in redux apps


var EMPTY_SCREEN_PROPS = {};

var getScreenProps = function getScreenProps() {
  return EMPTY_SCREEN_PROPS;
};

function createReactNavigationReduxMiddleware(navStateSelector) {
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "root";
  return function (store) {
    return function (next) {
      return function (action) {
        var oldState = store.getState();
        var result = next(action);
        var newState = store.getState();
        triggerAllSubscribers(key, {
          type: 'action',
          action: action,
          state: navStateSelector(newState),
          lastState: navStateSelector(oldState)
        });
        return result;
      };
    };
  };
}

var delayedTriggers = new Map();

function triggerAllSubscribers(key, payload) {
  var trigger = function trigger() {
    return getReduxSubscribers(key).forEach(function (subscriber) {
      return subscriber(payload);
    });
  };

  if (!payload.action.hasOwnProperty('type') || !payload.action.type.startsWith("Navigation") || payload.state === payload.lastState) {
    trigger();
    return;
  }

  var existingTriggers = delayedTriggers.get(key);

  if (existingTriggers) {
    existingTriggers.push(trigger);
  } else {
    delayedTriggers.set(key, [trigger]);
  }
}

function triggerDelayedSubscribers(key) {
  var triggers = delayedTriggers.get(key);

  if (!triggers) {
    return;
  }

  delayedTriggers.delete(key);
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = triggers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var trigger = _step.value;
      trigger();
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

function createDidUpdateCallback(key) {
  return triggerDelayedSubscribers.bind(null, key);
}

function initializeListeners(key, state) {
  triggerAllSubscribers(key, {
    type: 'action',
    action: initAction,
    state: state,
    lastState: null
  });
  triggerDelayedSubscribers(key);
}

function createNavigationPropConstructor(key) {
  return function (dispatch, state, router, getCurrentNavigation) {
    invariant(router, "App.router must be provided to createNavigationPropConstructor as of " + "react-navigation-redux-helpers@2.0.0. Learn more: " + "https://reactnavigation.org/docs/en/" + "redux-integration.html#breaking-changes-in-2.3");
    invariant(getCurrentNavigation, "getCurrentNavigation must be provided to createNavigationPropConstructor as of " + "react-navigation-redux-helpers@2.0.0. Learn more: " + "https://reactnavigation.org/docs/en/" + "redux-integration.html#breaking-changes-in-2.3");
    return getNavigation(router, state, dispatch, getReduxSubscribers(key), getScreenProps, getCurrentNavigation);
  };
}

export { createReactNavigationReduxMiddleware, createDidUpdateCallback, initializeListeners, createNavigationPropConstructor };